import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { devConfig, providersCasino, profile, countries } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterDepositReportsView.
 * @extends JetView
 */
export default class FilterDepositReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for date range
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the input
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
                {
                    view: 'datepicker', // Datepicker component
                    name: 'Date',
                    id: 'Date',
                    stringResult: true,
                    minWidth: 200,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the datepicker
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                    format: '%d %M %Y', // Date format
                    suggest: {
                        type: 'calendar',
                        body: {
                            maxDate: new Date(), // Maximum selectable date is today
                        },
                    },
                },
                {
                    view: 'radio', // Radio buttons for grouping option
                    name: 'GroupedOnlyAffiliateUser',
                    label: _('Agrupado sólo por usuario afiliador'), // Label for the radio group
                    labelPosition: 'top',
                    value: 2, // Default selected value
                    options: [
                        { id: 1, value: _('Sí') }, // Option for 'Yes'
                        { id: 2, value: _('No') }, // Option for 'No'
                    ],
                },
            ],
        };
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Rich select dropdown for type selection
                    name: 'Type',
                    localId: 'provider:combo',
                    label: _('Tipo'), // Label for the dropdown
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        { id: '0', value: _('Mensual') }, // Monthly option
                        { id: '1', value: _('Diario') }, // Daily option
                    ],
                },
                {
                    view: 'radio', // Radio buttons for viewing option
                    name: 'OnlyBetShop',
                    label: _('Ver sólo por punto de venta'), // Label for the radio group
                    labelPosition: 'top',
                    value: 2, // Default selected value
                    options: [
                        { id: 1, value: _('Sí') }, // Option for 'Yes'
                        { id: 2, value: _('No') }, // Option for 'No'
                    ],
                },
            ],
        };
        const transactionId = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for transaction ID
                    name: 'TransactionId',
                    type: 'number', // Input type set to number
                    label: _('Transacción ID'), // Label for the input
                    labelPosition: 'top',
                    placeholder: _('Transacción ID'), // Placeholder text
                    invalidMessage: _('Transacción ID is required'), // Error message for validation
                },
            ],
        };
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo', // Combo box for selecting Bet Shop
                    name: 'BetShopId',
                    label: "<span class='icon-shop'></span>" + _('Punto de Venta'), // Label for the combo
                    hidden: !devConfig.getPermAction('filterByBetShop', 'Add'), // Visibility based on permissions
                    css: 'prm-filterByBetShop',
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    id: 'BetShopId',
                    options: {
                        body: {
                            dataFeed: function (text) {
                                // Function to fetch data for the combo
                                var vthis = this; // Reference to the current context
                                if (text.length > 2) {
                                    // Fetch data if input length is greater than 2
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Setting content type for the request
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/Select/BetShopsSelect', // API endpoint for fetching Bet Shops
                                            '{"Filter":"' + text + '"}', // Request body with filter
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error message on failure
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var resp = JSON.parse(text); // Parse the response
                                                    if (!resp.HasError) {
                                                        // Check for errors in response
                                                        vthis.parse(resp.Data); // Populate the combo with data
                                                    }
                                                },
                                            },
                                        );
                                }
                            },
                        },
                    },
                },
                {
                    view: 'radio', // Radio buttons for commission option
                    name: 'MyCommission',
                    label: _('Mi comisión'), // Label for the radio group
                    labelPosition: 'top',
                    value: 2, // Default selected value
                    options: [
                        { id: 1, value: _('Sí') }, // Option for 'Yes'
                        { id: 2, value: _('No') }, // Option for 'No'
                    ],
                },
            ],
        };
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Rich select dropdown for country selection
                    name: 'CountrySelect',
                    id: 'CountrySelect',
                    minWidth: 200,
                    label: "<span class='icon-language'></span>" + _('País'), // Label for the dropdown
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: {
                        body: {
                            template: function (obj) {
                                // Template for displaying country options
                                return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                            },
                            data: countries, // Data source for countries
                        },
                    },
                    hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Visibility based on permissions
                    css: 'prm-filterByCountry',
                },
                {
                    view: 'richselect', // Rich select dropdown for secondary country selection
                    name: 'CountrySelect2',
                    minWidth: 200,
                    label: "<span class='icon-language'></span>" + _('País'), // Label for the dropdown
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    value: profile.Settings.ReportCountry, // Default value from profile settings
                    readonly: true, // Set to readonly
                    options: {
                        body: {
                            template: function (obj) {
                                // Template for displaying country options
                                return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                            },
                            data: countries, // Data source for countries
                        },
                    },
                    hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Visibility based on permissions
                    css: 'prm-filterByCountry',
                    css: 'country-hide',
                },
            ],
        };
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Layout structure for the upper section
                },
            ],
        };
        const buttons = {
            margin: 10,
            minWidth: 200,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'), // Button label
                    width: 100,
                    click: () => {
                        this.getRoot().clear(); // Clear the form values
                    },
                },
                {
                    view: 'button', // Button to submit the form
                    value: _('Consultar'), // Button label
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country if report is enabled
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if not applicable
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if applicable
                            }
                        }
                        this.app.callEvent('depositReport:filter', [
                            filterdata, // Trigger event with filter data
                        ]);
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };
        const buttons2 = {
            margin: 10,
            minWidth: 200,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the second form
                    value: _('Limpiar'), // Button label
                    width: 100,
                    click: () => {
                        $$('myForm2').clear(); // Clear the second form values
                    },
                },
                {
                    view: 'button', // Button to submit the second form
                    value: _('Consultar'), // Button label
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get second form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country if report is enabled
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if not applicable
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if applicable
                            }
                        }
                        this.app.callEvent('depositReport:filter', [
                            filterdata, // Trigger event with filter data
                        ]);
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion component for collapsible sections
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion section
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Content of the accordion
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            padding: 10,
            rows: [upper_section, buttons2], // Content for the second accordion section
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Title for the popup
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3], // Content of the form in the popup
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for the form
                },
            },
        });
        return {
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Display accordion if screen size is sufficient
                    : { id: 'right2', height: 1, width: screen.width - 54 }, // Fallback for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object passed to the init method.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date input if not applicable
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date input if applicable
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
        });
    }
}

// FILE DOCUMENTED
